import React, { cloneElement } from "react";
import {
  Button,
  Datagrid,
  Filter,
  ReferenceField,
  ResourceContextProvider,
  RowClickFunction,
  sanitizeListRestProps,
  SearchInput,
  ShowProps,
  TextField,
  TopToolbar,
  useListContext,
} from "react-admin";

import SanitizedGrid from "components/SanitizedGrid";
import { Grid, Typography } from "@material-ui/core";
import IconPlus from "@material-ui/icons/Add";
import { GetParam } from "utils/tools";
import StatusField from "components/StatusField";
import { PaddingDenseStyled2List } from "../../components/ListWrapper";
import CustomPagination from "../../components/CustomPagination";

const ThisFilter = (props: any) => (
  <Filter {...props}>
    <SearchInput source="search" alwaysOn />
  </Filter>
);

const ListActions = (props: any) => {
  const param = GetParam();
  const { className, exporter, filters, maxResults, history, ...rest } = props;
  const { resource, displayedFilters, filterValues, showFilter } =
    useListContext();
  return (
    <TopToolbar className={className} {...sanitizeListRestProps(rest)}>
      {filters &&
        cloneElement(filters, {
          resource,
          showFilter,
          displayedFilters,
          filterValues,
          context: "button",
        })}

      <Button
        onClick={() =>
          history.push(
            `/levelGroups/create?source=${JSON.stringify({
              levelId: Number(props.filterValues?.LevelId),
            })}&schoolId=${param.get("schoolId")}&levelId=${
              props.filterValues?.LevelId
            }`
          )
        }
        label="Create Class"
      >
        <IconPlus />
      </Button>
    </TopToolbar>
  );
};

const Class = (props: ShowProps) => {
  const param = GetParam();

  const rowClick: RowClickFunction = (id) =>
    `/levelGroups/${id}?schoolId=${param.get("schoolId")}&levelId=${props.id}`;

  return (
    <SanitizedGrid container spacing={2}>
      <Grid item xs={12}>
        <Typography variant="h6">Classes</Typography>
      </Grid>

      <Grid item xs={12}>
        <ResourceContextProvider value="levelGroups">
          <PaddingDenseStyled2List
            {...props}
            exporter={false}
            hasCreate={false}
            filters={<ThisFilter {...props} />}
            filterDefaultValues={{
              LevelId: parseInt(props.id),
            }}
            bulkActionButtons={false}
            title=" "
            sort={{
              field: "levelId",
              order: "ASC",
            }}
            actions={<ListActions history={props.history} />}
            pagination={<CustomPagination />}
          >
            <Datagrid rowClick={rowClick}>
              <ReferenceField label="Level" source="levelId" reference="levels">
                <TextField source="name" />
              </ReferenceField>
              <TextField source="name" label="Class" />
              <StatusField source="status" />
            </Datagrid>
          </PaddingDenseStyled2List>
        </ResourceContextProvider>
      </Grid>
    </SanitizedGrid>
  );
};

export default Class;
